<template>
  <v-container fluid>
    <v-card class="elevation-2 py-1 px-6 mt-4 rounded-lg">
      <v-row class="px-4 pb-0 pt-3">
        <h3>Estimators</h3>
      </v-row>
      <v-container class="mt-5">
        <v-data-table :headers="headers" :items="data_applicators" class="elevation-1"></v-data-table>
      </v-container>
    </v-card>

  </v-container>
</template>

<script>
import axios from "@/api/axios-auth";


export default {
  name: 'Sellnetics_Estimations',

  data() {
    return {
      message: 'Hello World',
      loaded: false,
      data_applicators: [],
      pagination: {
        page: 1
      },
      hoverOnTable: false,
      headers: [
        {text: 'Customer Name', value: 'CustomerName', class: 'black--text', filterable: false, sortable: true},
        {text: 'Customer Email', value: 'CustomerEmail', class: 'black--text'},
        {text: 'Create Date', value: 'CreateDate', class: 'black--text'},
        {text: 'Source', value: 'Source', class: 'black--text'},
        {text: 'Phone Number', value: 'PhoneNumber', class: 'black--text'},
        {text: 'Company Name', value: 'CompanyName', class: 'black--text'},
        {text: 'Project Name', value: 'ProjectName', class: 'black--text'},
        {text: 'Project Address', value: 'ProjectAddress', class: 'black--text'},
        {text: 'ZIP', value: 'ZIP', class: 'black--text'},
      ],

    };
  },
  created() {

    this.loadApplicatorsData()
  },

  methods: {
    greet() {
      alert(this.message);
    },
    loadApplicatorsData(){
      this.data_applicators = [];

      axios.get('/rural-estim/get-estim-projects-tables', {

        params: {
          Offset: 0,
          Limit: 100000,
          OrderBy: 'CreateDate',
          OrderDirAsc: true,
          IsCountRequired: true
        }
      })
          .then((resp)=>{

            this.data_applicators = resp.data.data.data;
            this.loaded = false;
          })
    },
  },
  mounted() {
    console.log('Component has been mounted');
  }
};
</script>




<style >

</style>
